import React, { ReactElement, useState } from "react";
import useKeyboardShortcuts from "../../../contexts/KeyboardShortcutContext";
import useSelectionState, { AssignmentType, Ticket } from "../../../pages/agent/selection-state";
import { ChatStatus, useIgnoreMutation } from "../../../__generated__/api";
import TimedToast from "../../timed-toast/TimedToast";

interface Props {
    refreshData?: () => void
}
export default function Ignore(props: Props): ReactElement {
    const selectionState = useSelectionState();
    const [sendIgnore] = useIgnoreMutation();

    const [lastIgnored, setLastIgnored] = useState<Ticket[]>([]);
    const [openedId, setOpenedId] = useState<string>();

    const ignore = (tickets?: Ticket[]) => {
        const selection = tickets ?? selectionState
            .getSelection()
            .filter(ticket => ticket.status === ChatStatus.ChatRequested);
        const selectedIds = selection.toIdList("id") as string[];

        setOpenedId(selectionState.currentId && selectedIds.includes(selectionState.currentId)
            ? selectionState.currentId
            : undefined);

        selectionState.closeCurrent();
        selectionState.setChatStatuses(selectedIds, ChatStatus.Ignored);
        selectionState.hide(...selectedIds);

        setLastIgnored(selection);
    };

    const doIgnore = async (tickets?: Ticket[]) => {
        const selectedIds = (tickets ?? lastIgnored).toIdList("id");

        await sendIgnore({
            variables: {
                ids: selectedIds,
            },
        });
        setLastIgnored([]);
        setOpenedId(undefined);
    };

    const onCancel = () => {
        lastIgnored.forEach(ticket => {
            selectionState.setChatStatus(
                ticket.id,
                ticket.status,
                ticket.isAssignedToCurrentUser ? AssignmentType.CURRENT_USER : AssignmentType.NONE,
            );
            selectionState.unhide(ticket.id as string);
        });
        if (openedId) {
            selectionState.setOpened(openedId);
        }
        setLastIgnored([]);
        setOpenedId(undefined);
        props.refreshData?.();
    };

    useKeyboardShortcuts(shortcuts => {
        shortcuts.on({
            shortcut: "shift+!",
            context: "default",
            handler: () => ignore(),
        });
        shortcuts.on({
            shortcut: "k+i",
            context: "default",
            description: "Ignore the conversation",
            group: "Conversations",
            handler: () => ignore(),
        });
    });

    selectionState.registerIgnoreHandler(tickets => {
        ignore(tickets);
    });

    return (
        <div>
            {lastIgnored.length > 0 && (
                <div className="fixed-bottom p-2">
                    <TimedToast
                        key={lastIgnored.toIdList("id").join()}
                        canCancel
                        title={`${lastIgnored.length} items ignored.`}
                        seconds={5}
                        onClose={doIgnore}
                        onCancel={onCancel}
                    >
                        <div>
                            You ignored
                            {" "}
                            {lastIgnored.length}
                            {" "}
                            items.
                            {" "}
                        </div>
                    </TimedToast>

                </div>
            )}
        </div>
    );
}

Ignore.defaultProps = {
    refreshData: () => {
        // nothing
    },
};
